import React from 'react';
import { claimCheck, localToday } from '../data/claimCheck';
import { getClaimRequirements } from '../data/claimRequirements';
import { claimCommittee } from '../data/claimPayload';

// RULING 277 (Bob, 2026-10-03): the claim check - one box at the top of the claim page, before anything else:
// what is right, what to fix, what to confirm, and the date. It reads; it never writes, sends or decides.
// The lists are the claim form's own (ClaimFormPanel reports its model up through onModel) - see src\data\claimCheck.js.
const C = { bg: '#0D1B2A', border: '#2E4A6B', text: '#DCE7F2', dim: '#8AA4BF', ok: '#40C070', fix: '#E8A020', info: '#7FB2E5' };

function List({ title, color, items }) {
  if (!items.length) return null;
  return (
    <div style={{ marginTop: 10 }}>
      <div style={{ fontSize: 12, fontWeight: 700, color, textTransform: 'uppercase', letterSpacing: 1 }}>{title} ({items.length})</div>
      <ul style={{ margin: '6px 0 0 18px', padding: 0, fontSize: 13, color: C.text, lineHeight: 1.5 }}>
        {items.map((x, i) => <li key={i}>{x}</li>)}
      </ul>
    </div>
  );
}

export default function ClaimCheckPanel({ claim, model, documentsCount }) {
  if (!claim || claim.status === 'draft') return null;
  const chk = claimCheck(claim, {
    model, documentsCount, committee: claimCommittee(claim),
    requirements: getClaimRequirements(claim.applicableAgreement),
    today: localToday(),   // Forensic audit 2026-10-16: the reader's calendar date - the UTC one closed the window a day early after 8pm Eastern
  });
  const d = chk.deadline;
  const head = chk.loading ? 'Checking the claim…'
    : chk.ready ? (d && d.served ? 'Ready, and served.' : 'Ready to serve.')
    : 'Not ready to serve.';
  return (
    <div className="card" style={{ marginBottom: 16, border: '1px solid ' + (chk.ready ? C.ok : C.fix) }}>
      <div className="card-header">
        <div>
          <div className="card-title">Claim check</div>
          <div className="card-subtitle">Read this before the claim goes to the Carrier. It checks the claim; it does not decide it.</div>
        </div>
      </div>
      <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', alignItems: 'baseline' }}>
        <div style={{ fontSize: 16, fontWeight: 700, color: chk.ready ? C.ok : C.fix }}>{head}</div>
        {d && !d.served ? (
          <div style={{ fontSize: 13, color: d.daysLeft != null && d.daysLeft <= 10 ? C.fix : C.text }}>
            Filing window closes {d.due}{d.daysLeft != null ? (d.daysLeft >= 0 ? ' - ' + d.daysLeft + ' day(s) left' : ' - closed ' + (-d.daysLeft) + ' day(s) ago') : ''}. Serve early.
          </div>
        ) : null}
      </div>
      <List title="Right" color={C.ok} items={chk.right} />
      <List title="Fix" color={C.fix} items={chk.fix} />
      <List title="Confirm" color={C.info} items={chk.confirm} />
    </div>
  );
}
